import getGreaterDate from "./getGreaterDate.js";
import toDate from "./toDate.js";
const differenceBetweenDates = (date1Param, date2Param)=>{
    const date1 = 'string' == typeof date1Param ? toDate(date1Param) : date1Param;
    const date2 = 'string' == typeof date2Param ? toDate(date2Param) : date2Param;
    const endDate = getGreaterDate(date1, date2);
    const startDate = date1 === endDate ? date2 : date1;
    if (!endDate || !startDate) return {
        milliseconds: 0,
        seconds: 0,
        minutes: 0,
        hours: 0,
        days: 0
    };
    const milliseconds = endDate.getTime() - startDate.getTime();
    if (milliseconds <= 0) return {
        milliseconds: 0,
        seconds: 0,
        minutes: 0,
        hours: 0,
        days: 0
    };
    const seconds = milliseconds / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    return {
        milliseconds: Math.round(100 * milliseconds) / 100,
        seconds: Math.round(100 * seconds) / 100,
        minutes: Math.round(100 * minutes) / 100,
        hours: Math.round(100 * hours) / 100,
        days: Math.round(100 * days) / 100
    };
};
const date_differenceBetweenDates = differenceBetweenDates;
export default date_differenceBetweenDates;
